import { mainColor, UNIT } from '../../constants/theme';

export const styles = () => ({
  root: {
    width: '100%',
    marginTop: UNIT,
    marginBottom: UNIT
  },
  title: {
    borderBottomColor: 'transparent'
  },
  icon: {
    fontSize: '24px',
    color: mainColor.colorBlack,
    align: 'center'
  },
  textField: {
    marginLeft: UNIT * 0.5,
    flexBasis: '20%',
    paddingRight: UNIT * 1.25,
    marginTop: 0,
    display: 'inline-block'
  },
  titleStyle: { fontSize: UNIT * 1.125, alignSelf: 'center' },
  tableCell: {
    borderBottomColor: 'transparent',
    textAlign: 'end',
    paddingRight: UNIT * 1.5
  }
});
